function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { ILoqateFindResultType } from 'swag-common/interfaces/address';
import classes from './autocomplete-address-list.scss';
class AutocompleteAddressListItem extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "getItem", () => {
      const {
        item
      } = this.props;
      switch (item.type) {
        case ILoqateFindResultType.Address:
          {
            return /*#__PURE__*/React.createElement("span", {
              onClick: this.setAddressClick,
              className: classes.row
            }, item.text, item.description && /*#__PURE__*/React.createElement("span", {
              className: classes.secondary
            }, ",\xA0", item.description));
          }
        case ILoqateFindResultType.ManualEnter:
          {
            return /*#__PURE__*/React.createElement("span", {
              onClick: this.handleAddressManuallyClick,
              className: classes.row
            }, `${item.text}${item.description}`);
          }
        default:
          {
            return /*#__PURE__*/React.createElement("span", {
              onClick: this.fetchAddressesClick,
              className: classes.row
            }, item.text, item.description && /*#__PURE__*/React.createElement("span", {
              className: classes.secondary
            }, ",\xA0", item.description), /*#__PURE__*/React.createElement("span", {
              className: classes.arrow
            }));
          }
      }
    });
    _defineProperty(this, "handleAddressManuallyClick", () => {
      this.props.onManualEnterClick();
    });
    _defineProperty(this, "setAddressClick", () => {
      const {
        item,
        onAddressSelect
      } = this.props;
      onAddressSelect({
        id: item.id
      });
    });
    _defineProperty(this, "fetchAddressesClick", () => {
      const {
        item,
        onAddressClick
      } = this.props;
      onAddressClick({
        container: item.id
      });
    });
  }
  render() {
    const {
      item
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.item,
      key: item.id
    }, this.getItem());
  }
}
export default AutocompleteAddressListItem;